import { config } from '../config';

export const initHubspot = () => {
    const { environment } = config;

    // Only load in production and staging
    const hubspotIds = {
        production: '4892644',
        staging: '49642184',
    };

    const hubspotId = hubspotIds[environment];
    if (!hubspotId) return; // Exit for other environments (dev, test)

    if (document.getElementById('hs-script-loader')) return;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${hubspotId}.js`;

    document.head.appendChild(script);
};
